import o, { useState as E, useEffect as x } from "react";
import { ExtraUnit as O } from "./index239.mjs";
import h from "./index240.mjs";
import { ToastState as F } from "./index90.mjs";
import M from "./index79.mjs";
import { useExtras as k } from "./index99.mjs";
import { useHotelConfig as D } from "./index93.mjs";
import "jotai";
import "@amenitiz/design-system";
import { useSummaryButton as P } from "./index155.mjs";
import { track as T } from "./index9.mjs";
import { TRACK_EVENT_TYPE as R, TRACK_EVENT as g } from "./index10.mjs";
import { getSubscriptionPlanRoot as A } from "./index14.mjs";
const G = ({
  cartItem: e,
  preFetchedExtras: s
}) => {
  const [a, m] = E(!1), [p, c] = E([]), {
    roomsAvailability: r,
    setExtrasToCart: C,
    setToast: S,
    addMandatoryExtrasToCart: b
  } = k(), { setSummaryButton: l } = P(), _ = e.id, { hotelId: u, propertySize: d, propertyType: y, subscriptionPlan: f } = D();
  return x(() => {
    s ? c(s.optional_extras) : (m(!0), M.getExtrasPerRoom(e).then(({ data: t }) => {
      c(t.optional_extras), b(t, _);
    }).finally(() => {
      m(!1);
    }));
  }, [e.totalChildren, e.totalAdults, e.roomId]), x(() => {
    l({
      disabled: a
    });
  }, [a, l]), a ? /* @__PURE__ */ o.createElement("div", { "data-testid": "extras-loading" }, "Loading...") : p.length === 0 ? /* @__PURE__ */ o.createElement("div", { "data-testid": "empty_extras" }, I18n.t("booking_engine.information.no_extras_room")) : /* @__PURE__ */ o.createElement("ul", { className: h.extras_container, "data-testid": "optional-extras-list" }, p.map((t, v) => {
    const i = e.optionalExtras.find(
      (n) => n.id === t.id
    );
    return /* @__PURE__ */ o.createElement(
      O,
      {
        extra: t,
        initialAmount: (i == null ? void 0 : i.amount) || 0,
        key: t.id,
        index: v,
        currency: r.currency,
        setExtras: (n) => {
          C({
            extra: n,
            cartItemId: _
          });
        },
        onAdd: () => {
          T(g.ADD_TO_CART, R.ADD_TO_CART, {
            hotel_id: u,
            property_type: y,
            property_size: d,
            subscription_plan: A(f),
            ecommerce: {
              currency: r.currency,
              value: parseFloat(t.total_price),
              items: [
                {
                  item_id: t.id,
                  item_name: t.name,
                  item_type: "extra",
                  price: parseFloat(t.total_price),
                  currency: r.currency,
                  quantity: 1
                }
              ]
            }
          }), S({
            message: I18n.t("booking_engine.information.extra_added"),
            state: F.SUCCESS
          });
        },
        onRemove: () => {
          T(
            g.REMOVE_FROM_CART,
            R.REMOVE_FROM_CART,
            {
              hotel_id: u,
              property_type: y,
              property_size: d,
              subscription_plan: A(f),
              ecommerce: {
                currency: r.currency,
                value: parseFloat(t.total_price),
                items: [
                  {
                    item_id: t.id,
                    item_name: t.name,
                    item_type: "extra",
                    price: parseFloat(t.total_price),
                    currency: r.currency,
                    quantity: 1
                  }
                ]
              }
            }
          );
        }
      }
    );
  }));
};
export {
  G as Extras
};
